import React from "react";
import { styled } from "@mui/system";
import { Box, IconButton, Tooltip } from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { connect } from "react-redux";
import DropdownMenu from "./DropdownMenu";
import ChosenOptionLebel from "./ChosenOptionLebel"
const MainContainer = styled("div")(({ hasServer }) => ({
  position: "absolute",
  top: 0,
  right: hasServer ? "240px" : 0,
  height: "48px",
  borderBottom: "1px solid black",
  backgroundColor: "#1f2024",
  width: hasServer ? "calc(100% - 560px)" : "calc(100% - 296px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 12px",
  boxSizing: "border-box",
}));
const AppBar = ({ selectedServer }) => {
  return (
    <MainContainer hasServer={Boolean(selectedServer)}>
      <ChosenOptionLebel/>
      <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {selectedServer && (
          <Tooltip title="Показать список участников">
            <IconButton sx={{ color: "#b5bac1" }}>
              <PeopleAltIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        )}
        <DropdownMenu />
      </Box>
    </MainContainer>
  );
};

const mapStoreStateToProps = ({ room }) => ({
  selectedServer: room.selectedServer,
});

export default connect(mapStoreStateToProps)(AppBar);
